import styled from 'styled-components';

export const PerformanceRatchetTierEditStyles = styled.div`
	padding: 1rem;

	.fields-row {
		display: flex;
		width: 100%;
	}

	.field {
		flex: 1;

		&:not(:last-child) {
			margin-right: 1rem;
		}
	}

	.field-label {
		font-weight: 600;
	}

	.actions-row {
		display: flex;
		justify-content: space-between;
		margin-top: 1rem;
	}

	.cancel-button {
		background: white;
		border: 0;
		color: ${({ theme }) => theme.v3.colors.red[6]};
		display: flex;
		align-items: center;
		font-weight: 700;
		font-size: 0.875rem;
		cursor: pointer;

		&:hover {
			color: ${({ theme }) => theme.v3.colors.red[8]};
		}

		svg {
			margin-right: 0.25rem;
		}
	}

	.save-button {
		background: ${({ theme }) => theme.v3.colors.blue[6]};
		color: white;
		padding: 0.5rem;
		font-weight: 600;
		border-radius: 0.25rem;
		border: none;
		display: flex;
		align-items: center;
		cursor: pointer;

		&:hover {
			background: ${({ theme }) => theme.v3.colors.blue[7]};
		}

		svg {
			margin-right: 0.25rem;
		}
	}
`;

export const PerformanceRatchetTierSummaryStyles = styled.div`
	margin: 0 0.5rem 0 auto;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 1rem;
	padding: 0 0.5rem;

	.performance-ratchet-tier-summary {
		white-space: nowrap;
	}
`;
